if (!customElements.get('rk-cart-addons')) {
  class RkCartAddons extends HTMLElement {
    connectedCallback() {
      this.pickWeighted();
    }

    pickWeighted() {
      const cards = Array.from(this.querySelectorAll('.rk-cart-addon-card'));
      if (!cards.length) return;

      const count = Math.min(3, cards.length);
      // Earlier cards (better sellers, collection is sorted best-selling)
      // get a higher weight, but every card keeps a non-zero chance.
      const pool = cards.map((el, i) => ({ el, weight: cards.length - i }));
      const chosen = [];

      for (let n = 0; n < count; n++) {
        const totalWeight = pool.reduce((sum, item) => sum + item.weight, 0);
        let roll = Math.random() * totalWeight;
        let index = 0;
        for (; index < pool.length - 1; index++) {
          roll -= pool[index].weight;
          if (roll <= 0) break;
        }
        chosen.push(pool.splice(index, 1)[0]);
      }

      cards.forEach((card) => card.classList.add('rk-cart-addon-card--hidden'));
      chosen.forEach((item) => item.el.classList.remove('rk-cart-addon-card--hidden'));
    }
  }
  customElements.define('rk-cart-addons', RkCartAddons);
}